import { Reducer } from 'redux'
import {
  addCollection,
  closeCreateCollection,
  openCreateCollection,
  resetTeamRelationship,
  setCollections,
  setCreationStep,
  setDraftCollectionName,
  setDraftCollectionType,
  setDraftSelectedMemberIds,
  toggleDraftMember,
  TeamRelationshipActionTypes,
} from './action'
import {
  DUMMY_TEAM_RELATIONSHIP_RESPONSE,
  normalizeCollections,
  normalizeTeamRelationshipResponse,
} from './dummyData'
import { CollectionDraft, TeamRelationshipState } from './types'

const emptyDraft: CollectionDraft = {
  type: null,
  name: '',
  selectedMemberIds: [],
}

const dummyState = normalizeTeamRelationshipResponse(
  DUMMY_TEAM_RELATIONSHIP_RESPONSE
)

export const initialState: TeamRelationshipState = {
  collectionsById: dummyState.collectionsById,
  collectionIds: dummyState.collectionIds,
  membersById: dummyState.membersById,
  memberIds: dummyState.memberIds,
  creationStep: 'closed',
  draft: emptyDraft,
}

type TeamRelationshipAction =
  | ReturnType<typeof openCreateCollection>
  | ReturnType<typeof closeCreateCollection>
  | ReturnType<typeof setCreationStep>
  | ReturnType<typeof setDraftCollectionType>
  | ReturnType<typeof setDraftCollectionName>
  | ReturnType<typeof setDraftSelectedMemberIds>
  | ReturnType<typeof toggleDraftMember>
  | ReturnType<typeof addCollection>
  | ReturnType<typeof setCollections>
  | ReturnType<typeof resetTeamRelationship>

export const reducer: Reducer<TeamRelationshipState, TeamRelationshipAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case TeamRelationshipActionTypes.OPEN_CREATE_COLLECTION:
      return {
        ...state,
        creationStep: 'selectType',
        draft: emptyDraft,
      }
    case TeamRelationshipActionTypes.CLOSE_CREATE_COLLECTION:
      return {
        ...state,
        creationStep: 'closed',
        draft: emptyDraft,
      }
    case TeamRelationshipActionTypes.SET_CREATION_STEP:
      return {
        ...state,
        creationStep: action.payload,
      }
    case TeamRelationshipActionTypes.SET_DRAFT_COLLECTION_TYPE:
      return {
        ...state,
        draft: {
          ...state.draft,
          type: action.payload,
        },
      }
    case TeamRelationshipActionTypes.SET_DRAFT_COLLECTION_NAME:
      return {
        ...state,
        draft: {
          ...state.draft,
          name: action.payload,
        },
      }
    case TeamRelationshipActionTypes.SET_DRAFT_SELECTED_MEMBER_IDS:
      return {
        ...state,
        draft: {
          ...state.draft,
          selectedMemberIds: action.payload,
        },
      }
    case TeamRelationshipActionTypes.TOGGLE_DRAFT_MEMBER: {
      const memberId = action.payload
      const selected = state.draft.selectedMemberIds
      const selectedMemberIds = selected.includes(memberId)
        ? selected.filter(id => id !== memberId)
        : [...selected, memberId]
      return {
        ...state,
        draft: {
          ...state.draft,
          selectedMemberIds,
        },
      }
    }
    case TeamRelationshipActionTypes.ADD_COLLECTION: {
      const collection = action.payload
      if (state.collectionsById[collection.id]) {
        return state
      }
      return {
        ...state,
        collectionsById: {
          ...state.collectionsById,
          [collection.id]: collection,
        },
        collectionIds: [...state.collectionIds, collection.id],
      }
    }
    case TeamRelationshipActionTypes.SET_COLLECTIONS:
      return {
        ...state,
        ...normalizeCollections(action.payload),
      }
    case TeamRelationshipActionTypes.RESET_TEAM_RELATIONSHIP:
      return initialState
    default:
      return state
  }
}
